'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAppInForeground = exports.setAppInBackground = undefined;
exports.setWindowVisible = setWindowVisible;

var _reduxActions = require('redux-actions');

var _VisitorActionTypes = require('../constants/VisitorActionTypes');

var setAppInBackground = exports.setAppInBackground = (0, _reduxActions.createAction)(_VisitorActionTypes.APP_IN_BACKGROUND);
var setAppInForeground = exports.setAppInForeground = (0, _reduxActions.createAction)(_VisitorActionTypes.APP_IN_FOREGROUND);

function setWindowVisible(isVisible) {
  return function (dispatch) {
    if (isVisible) {
      dispatch(setAppInForeground());
    } else {
      dispatch(setAppInBackground());
    }
  };
}